import { isEmptyObject } from 'libs/utils';
import { APP_CACHE_STORAGE_DRIVER } from '../config';
import logger from '../libs/logger';

export default {
  getRefToken() {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.getItem('ref_token');
  },

  setRefToken(token: string) {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.setItem('ref_token', token);
  },

  getToken() {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.getItem('token');
  },

  setToken(token: string) {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.setItem('token', token);
  },

  clearToken() {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.removeItem('token');
  },

  removeSessionItem(key: string) {
    logger.debug(`Removing item from session storage: ${key}`);
    window.sessionStorage.removeItem(key);
  },

  setSessionItem(key: string, payload: string) {
    logger.debug(`Setting item in session storage: ${key}`);
    window.sessionStorage.setItem(key, payload);
  },

  getSessionItem(key: string) {
    logger.debug(`Getting item from session storage: ${key}`);
    return window.sessionStorage.getItem(key) as string;
  },

  removeItem(key: string) {
    logger.debug(`Removing item from storage: ${key}`);

    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.removeItem(key);
  },

  cacheForm(url: string, formData: any = {}, formName: string = 'Formark') {
    const formKey = `${formName}:${url}`;

    logger.debug(`Caching form data: ${formKey} / ${formName}`);

    if (!isEmptyObject(formData)) {
      localStorage.setItem(formKey, JSON.stringify(formData));
    }
  },

  setItem(key: string, payload: string) {
    logger.debug(`Setting storage item: ${key}`);

    const storage = window[APP_CACHE_STORAGE_DRIVER];
    storage.setItem(key, payload);
  },

  getStorageItem(key: string, isObject: boolean = false): string | object | null {
    logger.debug(`Getting storage item: ${key}`);

    let data: string | null = localStorage.getItem(key);

    if (isObject && data) data = JSON.parse(data);

    return data;
  },

  restoreCachedForm(
    alterURL?: string,
    formName: string = 'Formark'
  ): { [key: string]: string } {
    const url = alterURL || window.location.href;
    const formKey: string = `${formName}:${url}`;

    logger.debug(`Restoring form from cache: ${url} / ${formKey}`);

    const cachedFormData: string | null = localStorage.getItem(formKey);

    let cachedData = {};
    if (cachedFormData !== null && cachedFormData !== '') {
      cachedData = JSON.parse(cachedFormData);
    }

    return cachedData;
  },
};
